import React, { useContext } from 'react';
import { append, prop, propOr, isNotNil } from 'ramda';
import { isUserAdmin } from './pages/helpers/isUserAdmin';
import SignOutMutation from './_graphql/mutations/SignOutMutation';
import { isSuperAdminUserRole } from './components/users/utils/roles';
const UserContext = React.createContext();

export default function withUser (Component) {
  return function UserComponent (props) {
    return (
      <UserContext.Consumer>
        {({ user, userTeam, userRefetch, teams }) => {
          const flexigetsLib = append('flexigetDefault', propOr([], 'flexigets', userTeam));
          const isSuperAdmin = isSuperAdminUserRole(user);
          return (
            <Component
              {...props}
              user={user}
              userTeam={userTeam}
              flexigets={flexigetsLib}
              userIsSignedIn={isNotNil(prop('email', user))}
              userIsAdmin={isUserAdmin(user, userTeam)}
              userIsSuperAdmin={isSuperAdmin}
              onSignOut={() => SignOutMutation()}
              userRefetch={userRefetch}
              teams={teams}
            />
          );
        }}
      </UserContext.Consumer>
    );
  };
}

const useUserContext = () => {
  return useContext(UserContext);
};

export {
  UserContext,
  useUserContext
};
